import React from "react";

import * as Styled from "./styles";
import { ProsAndConsProps } from "./types";

const ProsAndCons: React.FC<ProsAndConsProps> = ({ pros, cons }) =>
  pros || cons ? (
    <Styled.Wrapper>
      {pros && <Styled.ProsWrapper>{pros}</Styled.ProsWrapper>}
      {cons && <Styled.ConsWrapper>{cons}</Styled.ConsWrapper>}
    </Styled.Wrapper>
  ) : null;

export default ProsAndCons;
